"use client";

import { SidebarGroup, SidebarMenu } from "@focal/ui-kit";
import { SidebarItem } from "@/components/common/AppSidebar/components/SidebarItem";
import { NavItem } from "@/components/common/AppSidebar/types";

export function NavMain({ items }: { items: NavItem[] }) {
  return (
    <SidebarGroup>
      <SidebarMenu>
        {items.map((item) => (
          <SidebarItem
            key={item.title}
            className="text-typography-primary"
            {...item}
          />
        ))}
      </SidebarMenu>
    </SidebarGroup>
  );
}
